import React from "react";
import "./App.css";
import LoadingPage from "./pages/LoadingPage/loading-page.component";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="App">
        <LoadingPage />
      </div>
    );
  }
}

export default App;
